import { TrainingClassesDocument, TrainingClassesQueryVariables } from 'generated/resources/graphql'

import { useQuery } from 'modules/core/hooks/useQuery'

type UseTrainingClassesParams = TrainingClassesQueryVariables & {
  skip?: boolean
}

export const useTrainingClasses = ({
  ids,
  trainingId,
  accessId,
  employeeId,
  skip,
}: UseTrainingClassesParams) => {
  const { loading, data, error } = useQuery(TrainingClassesDocument, {
    variables: { ids, trainingId, accessId, employeeId },
    skip,
  })

  return {
    error,
    loading,
    trainingStatus: data
      ? data.trainings.trainingMembershipsConnection.nodes[0]?.status
      : undefined,
    trainingMembershipId: data
      ? data.trainings.trainingMembershipsConnection.nodes[0]?.id
      : undefined,
    trainingClasses: data ? data.trainings.trainingClassesConnection.nodes : [], // Provide a default value
  }
}
